import React, { useContext, useEffect, useState } from 'react';
import GeneralJoyride from '../GeneralJoyride';
import { ManualContext } from '@f_qwep/context/Manual_context';
import { IconMaskotBook } from '@f_components/icons/IconMascotBook';

export function BatchPricerManual() {
    const { setChooseManual } = useContext(ManualContext);

    const [run, setRun] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const [steps, setSteps] = useState<any>([
        {
            target: '#root',
            title: 'Для чего функция "Проценка списком"',
            content: (
                <div>
                    {' '}
                    <IconMaskotBook />{' '}
                    <p>
                        При необходимости проценить нескольких десятков или сотен товаров воспользуйтесь «Проценкой
                        списком». Программа все проценит без вашего участия пока вы занимаетесь другими задачами.
                    </p>
                </div>
            ),
            disableBeacon: true,
            hideFooter: true,
            spotlightClicks: false,
            placement: 'center',
        },
    ]);

    useEffect(() => {
        setRun(true);
        setCurrentStep(0);
    }, []);

    const handleJoyrideCallback = (data: any) => {
        const { action, step, index, status, type } = data;

        if (type === 'step:after' && action === 'next' && !step.hideFooter) {
            setCurrentStep((prevStep) => prevStep + 1);
        } else if (type === 'step:before') {
        } else if (
            type === 'step:after' &&
            (action === 'skip' || action === 'close' || action === 'last' || action === 'skip')
        ) {
            setCurrentStep(0);
            setChooseManual();

            setRun(false);
        }
    };

    return (
        <div>
            <GeneralJoyride steps={steps} run={run} callback={handleJoyrideCallback} stepIndex={currentStep} />
        </div>
    );
}
